import fs from 'fs';
import path from 'path';
import unzipper from 'unzipper';
import { get } from 'lodash';
import { subDays } from 'date-fns';
import history from '@history';

import { HttpService } from 'app/services';
import * as AppActions from 'app/store/actions';
import { parseError } from 'helpers/Error';
import { JOB_STATUS, DEFAULT_CREATED_DATE } from '../../constants';

export const PRINT_JOB = '@JOB/PRINT_JOB';
export const PRINT_JOB_SUCCESS = '@JOB/PRINT_JOB_SUCCESS';
export const PRINT_JOB_FAIL = '@JOB/PRINT_JOB_FAIL';

export const DELETE_JOB = '@JOB/DELETE_JOB';
export const DELETE_JOB_SUCCESS = '@JOB/DELETE_JOB_SUCCESS';
export const DELETE_JOB_FAIL = '@JOB/DELETE_JOB_FAIL';

export const RESET_DATA = '@JOB/RESET_DATA';
export const RESET_FILE_DATA = '@JOB/RESET_FILE_DATA';

export const GENERATE_DATA = '@JOB/GENERATE_DATA';
export const GENERATE_DATA_SUCCESS = '@JOB/GENERATE_DATA_SUCCESS';
export const GENERATE_DATA_FAIL = '@JOB/GENERATE_DATA_FAIL';

export const PRINT_AND_PACK = '@JOB/PRINT_AND_PACK';
export const PRINT_AND_PACK_SUCCESS = '@JOB/PRINT_AND_PACK_SUCCESS';
export const PRINT_AND_PACK_FAIL = '@JOB/PRINT_AND_PACK_FAIL';

export const PRINT_LABEL = '@JOB/PRINT_LABEL';
export const PRINT_LABEL_SUCCESS = '@JOB/PRINT_LABEL_SUCCESS';
export const PRINT_LABEL_FAIL = '@JOB/PRINT_LABEL_FAIL';

export const REVERT_BACK_TO_DISTRIBUTION = '@JOB/REVERT_BACK_TO_DISTRIBUTION';
export const REVERT_BACK_TO_DISTRIBUTION_SUCCESS = '@JOB/REVERT_BACK_TO_DISTRIBUTION_SUCCESS';
export const REVERT_BACK_TO_DISTRIBUTION_FAIL = '@JOB/REVERT_BACK_TO_DISTRIBUTION_FAIL';

export const REVERT_BACK_TO_CHECKING = '@JOB/REVERT_BACK_TO_CHECKING';
export const REVERT_BACK_TO_CHECKING_SUCCESS = '@JOB/REVERT_BACK_TO_CHECKING_SUCCESS';
export const REVERT_BACK_TO_CHECKING_FAIL = '@JOB/REVERT_BACK_TO_CHECKING_FAIL';

export const GET_JOB_SUMMARY_DONE = '@JOB/GET_JOB_SUMMARY_DONE';

export const CHECK_IS_BARCODE = '@JOB/CHECK_IS_BARCODE';
export const GET_BARCODE_LIST = '@JOB/GET_BARCODE_LIST';

export const CLEAR_BARCODE = '@JOB/CLEAR_BARCODE';

export const QUICKKING_JOB_SUCCESS = '@JOB/QUICKKING_JOB_SUCCESS';

export const CHECK_CONFIRM_PASSWORD_REQUIRED = '@JOB_CHECK/CHECK_CONFIRM_PASSWORD_REQUIRED';
export const CHECK_CONFIRM_PASSWORD_REQUIRED_SUCCESS = '@JOB_CHECK/CHECK_CONFIRM_PASSWORD_REQUIRED_SUCCESS';
export const CHECK_CONFIRM_PASSWORD_REQUIRED_SUCCESS_END = '@JOB_CHECK/CHECK_CONFIRM_PASSWORD_REQUIRED_SUCCESS_END';
export const CHECK_CONFIRM_PASSWORD_REQUIRED_FAIL = '@JOB_CHECK/CHECK_CONFIRM_PASSWORD_REQUIRED_FAIL';

export const DOWLOAD_CSV_JOB = '@JOB/DOWLOAD_CSV_JOB';
export const DOWLOAD_CSV_JOB_SUCCESS = '@JOB/DOWLOAD_CSV_JOB_SUCCESS';
export const DOWLOAD_CSV_JOB_FAIL = '@JOB/DOWLOAD_CSV_JOB_FAIL';

export const previewJob = (jobIds, clientCode, packType) => {
  return (dispatch) => {
    dispatch({ type: PRINT_JOB, payload: { clientCode, packType } });
    HttpService.post('/api/packjobs/pdf', { ids: jobIds })
      .then((resp) => {
        dispatch({ type: PRINT_JOB_SUCCESS, payload: resp.data });
      })
      .catch((err) => {
        const { errorFields, errorMessages } = parseError(err);
        dispatch({ type: PRINT_JOB_FAIL, payload: { message: errorMessages.join('\n'), error: errorFields } });
        dispatch(AppActions.createDialogMessage('error', 'Error', errorMessages));
      });
  };
};

export const bulkPrintJob = (jobIds, isPacking = false, clientCode, packType) => {
  return (dispatch) => {
    dispatch({ type: PRINT_JOB, payload: { clientCode, packType } });
    HttpService.post('/api/packjobs/pdf', { ids: jobIds, isPacking })
      .then((resp) => {
        dispatch({ type: PRINT_JOB_SUCCESS, payload: resp.data });
      })
      .catch((err) => {
        const { errorFields, errorMessages } = parseError(err);
        dispatch({ type: PRINT_JOB_FAIL, payload: { message: errorMessages.join('\n'), error: errorFields } });
        dispatch(AppActions.createDialogMessage('error', 'Warning', errorMessages));
      });
  };
};

export const bulkRobotPackJob = (jobIds, clientCode, packType) => {
  return (dispatch) => {
    dispatch({ type: PRINT_JOB, payload: { clientCode, packType } });
    HttpService.post('/api/packjobs/robotpack', { ids: jobIds })
      .then((resp) => {
        dispatch({ type: PRINT_AND_PACK_SUCCESS, payload: resp.data });
      })
      .catch((err) => {
        const { errorFields, errorMessages } = parseError(err);
        dispatch({ type: PRINT_AND_PACK_FAIL, payload: { message: errorMessages.join('\n'), error: errorFields } });
        dispatch(AppActions.createDialogMessage('error', 'Warning', errorMessages));
      });
  };
};

export const downloadCSVAlpaca = (jobIds) => {
  return (dispatch) => {
    dispatch({ type: DOWLOAD_CSV_JOB });
    HttpService.post('/api/packjobs/alpaca-file', { jobIds: jobIds, isOnlyCSV: true }, { responseType: 'blob' })
      .then((resp) => {
        const blob = new Blob([resp], { type: 'application/zip' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `alpacafileexport-${new Date().getTime()}.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        dispatch({ type: DOWLOAD_CSV_JOB_SUCCESS });
      })
      .catch((err) => {
        const { errorFields, errorMessages } = parseError(err);
        dispatch({ type: DOWLOAD_CSV_JOB_FAIL, payload: { message: errorMessages.join('\n'), error: errorFields } });
        dispatch(AppActions.createDialogMessage('error', 'Error', errorMessages));
      });
  };
};

export const resetData = () => {
  return (dispatch) => {
    dispatch({ type: RESET_DATA });
  };
};

export const resetFileData = () => {
  return (dispatch) => {
    dispatch({ type: RESET_FILE_DATA });
  };
};

export const deleteJob = (jobIds) => {
  return (dispatch) => {
    dispatch({ type: DELETE_JOB });
    HttpService.put('/api/packjobs', { ids: jobIds })
      .then(() => {
        dispatch({ type: DELETE_JOB_SUCCESS });
        dispatch(
          AppActions.showMessage({
            message: 'job:DELETE_JOB_MESSAGE_SUCCESS',
            autoHideDuration: 4000,
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
            variant: 'success',
          }),
        );
      })
      .catch((err) => {
        const { errorFields, errorMessages } = parseError(err);
        dispatch({ type: DELETE_JOB_FAIL, payload: { message: errorMessages.join('\n'), error: errorFields } });
        dispatch(AppActions.createDialogMessage('error', 'Error', errorMessages));
      });
  };
};

export const reverseJob = (jobIds) => {
  return (dispatch) => {
    dispatch({ type: DELETE_JOB });
    HttpService.put('/api/packjobs/reverse', { ids: jobIds })
      .then(() => {
        dispatch({ type: DELETE_JOB_SUCCESS });
        dispatch(
          AppActions.showMessage({
            message: 'job:DELETE_JOB_MESSAGE_REVERSE',
            autoHideDuration: 4000,
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
            variant: 'success',
          }),
        );
      })
      .catch((err) => {
        const { errorFields, errorMessages } = parseError(err);
        dispatch({ type: DELETE_JOB_FAIL, payload: { message: errorMessages.join('\n'), error: errorFields } });
        dispatch(AppActions.createDialogMessage('error', 'Error', errorMessages));
      });
  };
};

export const generateDataFile = (jobIds, currentPharmacyId) => {
  return (dispatch) => {
    dispatch({ type: GENERATE_DATA });
    let savePath;
    HttpService.get(`api/pharmacies/${currentPharmacyId}/configuration`)
      .then((resp) => {
        savePath = !resp.data.alpacaFileExportFolder
          ? ''
          : path.join(resp.data.alpacaFileExportFolder, 'alpaca-exported.zip');
      })
      .finally(() => {
        if (!savePath) {
          savePath = window.electron.dialog.showSaveDialogSync(null, {
            filters: [{ extensions: ['zip'] }],
          });
          if (!savePath) {
            dispatch({
              type: GENERATE_DATA_SUCCESS,
            });
            return;
          }
        }
        HttpService.downloadFile('/api/packjobs/alpaca-file', 'post', { JobIds: jobIds }).then(
          async (response) => {
            const buffer = Buffer.from(await response.data.arrayBuffer());
            fs.writeFile(savePath, buffer, async (error) => {
              if (error) {
                const { errorFields, errorMessages } = parseError(error);
                dispatch({
                  type: GENERATE_DATA_FAIL,
                  payload: { message: errorMessages.join('\n'), error: errorFields },
                });
                dispatch(
                  AppActions.showMessage({
                    message: errorMessages,
                    autoHideDuration: 4000,
                    anchorOrigin: {
                      vertical: 'top',
                      horizontal: 'right',
                    },
                    variant: 'error',
                  }),
                );
              } else {
                const zip = fs.createReadStream(savePath).pipe(unzipper.Parse({ forceStream: true }));
                // eslint-disable-next-line no-restricted-syntax
                for await (const entry of zip) {
                  const fileName = entry.path;

                  const dirPath = path.dirname(savePath);
                  let filePath = path.join(dirPath, fileName);
                  const ext = path.extname(fileName);
                  const name = path.basename(fileName, ext);

                  let i = 1;
                  while (fs.existsSync(filePath)) {
                    const newName = `${name} (${i})${ext}`;
                    filePath = path.join(dirPath, newName);
                    i += 1;
                  }
                  entry.pipe(fs.createWriteStream(filePath));
                }
                fs.unlinkSync(savePath);
                dispatch({ type: GENERATE_DATA_SUCCESS });
                dispatch(
                  AppActions.showMessage({
                    message: 'job:GENERATE_DATA_SUCCESS',
                    autoHideDuration: 4000,
                    anchorOrigin: {
                      vertical: 'top',
                      horizontal: 'right',
                    },
                    variant: 'success',
                  }),
                );
              }
            });
          },
          (err) => {
            const { errorFields, errorMessages } = parseError(err);
            dispatch({
              type: GENERATE_DATA_FAIL,
              payload: { message: errorMessages.join('\n'), error: errorFields },
            });
            dispatch(
              AppActions.showMessage({
                message: errorMessages,
                autoHideDuration: 4000,
                anchorOrigin: {
                  vertical: 'top',
                  horizontal: 'right',
                },
                variant: 'error',
              }),
            );
          },
        );
      });
  };
};

export const printAndPack = (jobIds, clientCode, packType) => {
  return (dispatch) => {
    dispatch({ type: PRINT_AND_PACK, payload: { clientCode, packType } });
    HttpService.post('/api/packjobs/complete-printing', { ids: jobIds })
      .then((resp) => {
        dispatch({ type: PRINT_AND_PACK_SUCCESS, payload: resp.data });
      })
      .catch((err) => {
        const { errorFields, errorMessages } = parseError(err);
        dispatch({ type: PRINT_AND_PACK_FAIL, payload: { message: errorMessages.join('\n'), error: errorFields } });
        dispatch(AppActions.createDialogMessage('error', 'Error', errorMessages));
      });
  };
};

export const printLabel = (jobIds, startPosiion) => {
  return (dispatch) => {
    dispatch({ type: PRINT_LABEL });
    HttpService.post('/api/packjobs/print-label', {
      jobIds,
      startPosiion,
    })
      .then((resp) => {
        dispatch({ type: PRINT_LABEL_SUCCESS, payload: resp.data });
      })
      .catch((err) => {
        const { errorFields, errorMessages, errorTitle } = parseError(err);
        dispatch({ type: PRINT_LABEL_FAIL, payload: { message: errorMessages.join('\n'), error: errorFields } });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
};

export const getJobSummary = (filter) => {
  return (dispatch) => {
    const today = new Date();
    const from = get(filter, 'createdDateFrom');
    const to = get(filter, 'createdDateTo');

    const _filter =
      from === null
        ? {}
        : {
            createdDateFrom: from || subDays(today, DEFAULT_CREATED_DATE),
            createdDateTo: to || today,
          };

    HttpService.post('/api/packjobs/summary', { pageIndex: 1, pageSize: 99999, ..._filter }).then((resp) => {
      dispatch({ type: GET_JOB_SUMMARY_DONE, payload: resp.data });
    });
  };
};

export const getBarcodeList = (barcode, jobPhase) => {
  return (dispatch) => {
    if (barcode) {
      const code = barcode;
      dispatch({ type: CHECK_IS_BARCODE, payload: barcode });
      if (jobPhase === JOB_STATUS.CHECKING) {
        HttpService.get(`api/packjobs/barcode/${code}/checking`)
          .then((resp) => {
            dispatch({ type: GET_BARCODE_LIST, payload: resp?.data });
          })
          .catch((error) => {
            const errorMessages = error.response?.data;
            dispatch(
              AppActions.createDialogMessage(
                'error',
                error.response?.status === 400 ? 'Warning' : 'Error',
                errorMessages,
              ),
            );
          });
      } else {
        let url = `api/packjobs/barcode/${code}`;
        if (jobPhase === JOB_STATUS.PACKING) {
          url = `${url}?isPacking=true`;
        }
        HttpService.get(url)
          .then((resp) => {
            if (jobPhase === JOB_STATUS.PACKING) {
              const jobs = resp?.data ?? { packJobs: [] };
              const correctJob = jobs.packJobs.find(
                (s) => s.status.toString() === JOB_STATUS.CORRECT && s.barcode === barcode,
              );
              if (correctJob != null) {
                history.push(`/job/correct/${correctJob.jobId}?tab=${JOB_STATUS.PACKING}`);
              } else {
                dispatch({ type: GET_BARCODE_LIST, payload: resp?.data });
              }
            } else {
              dispatch({ type: GET_BARCODE_LIST, payload: resp?.data });
            }
          })
          .catch((error) => {
            const errorMessages = error.response?.data;
            dispatch(AppActions.createDialogMessage('error', 'Error', errorMessages));
          });
      }
    }
  };
};

export function completeCheckingConfirmPass(jobIds, username = '', password = '') {
  return (dispatch) => {
    dispatch({ type: CHECK_CONFIRM_PASSWORD_REQUIRED });
    return HttpService.put('/api/packjobs/confirmpass-checking', { jobIds, username, password })
      .then((resp) => {
        dispatch({ type: CHECK_CONFIRM_PASSWORD_REQUIRED_SUCCESS, payload: { data: resp.data } });
        dispatch(AppActions.showMessage({ message: 'job:COMPLETE_COMFIRM_PASS_MESSAGEWARNING_MESSAGE' }));
      })
      .catch((err) => {
        const { errorFields, errorMessages, errorTitle } = parseError(err);
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
        dispatch({ type: CHECK_CONFIRM_PASSWORD_REQUIRED_FAIL, payload: { message: errorMessages.join('\n') } });
      });
  };
}

export const revertBackToDistribution = (jobIds) => {
  return (dispatch) => {
    dispatch({ type: REVERT_BACK_TO_DISTRIBUTION });
    HttpService.put(`/api/packjobs/revert-completed-jobs`, jobIds)
      .then(() => {
        dispatch({ type: REVERT_BACK_TO_DISTRIBUTION_SUCCESS });
        dispatch(
          AppActions.showMessage({
            message: 'job:REVERT_BACK_TO_DISTRIBUTION_SUCCESS',
            autoHideDuration: 4000,
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
            variant: 'success',
          }),
        );
      })
      .catch((err) => {
        const { errorFields, errorMessages } = parseError(err);
        dispatch({
          type: REVERT_BACK_TO_DISTRIBUTION_FAIL,
          payload: { message: errorMessages.join('\n'), error: errorFields },
        });
        dispatch(AppActions.createDialogMessage('error', 'Error', errorMessages));
      });
  };
};

export const clearBarcode = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_BARCODE });
  };
};

export const clearPasswordChecking = () => {
  return (dispatch) => {
    dispatch({ type: CHECK_CONFIRM_PASSWORD_REQUIRED_SUCCESS_END });
  };
};

export const revertBackToChecking = (jobIds) => {
  return (dispatch) => {
    dispatch({ type: REVERT_BACK_TO_CHECKING });
    return HttpService.put('/api/packjobs/revert-back-to-checking', { jobIds })
      .then(() => {
        dispatch({ type: REVERT_BACK_TO_CHECKING_SUCCESS });
        dispatch(
          AppActions.showMessage({
            message: 'job:REVERT_TO_CHECKING_MESSAGE',
            autoHideDuration: 4000,
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
            variant: 'success',
          }),
        );
      })
      .catch((err) => {
        const { errorFields, errorMessages } = parseError(err);
        dispatch({
          type: REVERT_BACK_TO_CHECKING_FAIL,
          payload: { message: errorMessages.join('\n'), error: errorFields },
        });
        dispatch(AppActions.createDialogMessage('error', 'Error', errorMessages));
      });
  };
};
